/**
 * Auth Service
 * Abstraction des appels API d'authentification
 * Garde les composants propres en centralisant la logique
 */

import api from "./api";

export const authService = {
  /**
   * Login universel
   */
  login: async ({ email, password }) => {
    const { data } = await api.post("/api/auth/login", { email, password });
    return data;
  },

  /**
   * Demande de réinitialisation de mot de passe
   */
  forgotPassword: async ({ email }) => {
    const { data } = await api.post("/api/auth/forgot-password", { email });
    return data;
  },

  /**
   * Validation d'un token (invitation ou reset)
   */
  validateToken: async ({ token, token_type }) => {
    const { data } = await api.get("/api/auth/validate-token", {
      params: { token, token_type },
    });
    return data;
  },

  /**
   * Définir un mot de passe (invitation ou reset)
   */
  setPassword: async ({ token, new_password }) => {
    const { data } = await api.post("/api/auth/set-password", {
      token,
      new_password,
    });
    return data;
  },

  /**
   * Obtenir les infos de l'utilisateur connecté
   */
  me: async () => {
    const { data } = await api.get("/api/auth/me");
    return data;
  },

  /**
   * Changer le mot de passe (utilisateur connecté)
   */
  changePassword: async ({ current_password, new_password }) => {
    const { data } = await api.put("/api/auth/change-password", {
      current_password,
      new_password,
    });
    return data;
  },
};
